import produce from 'immer';
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, AtualizarNaturalidade } from './types';

export const INITIAL_STATE: AtualizarNaturalidade = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): AtualizarNaturalidade {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_NATURALIDADE: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.ATUALIZAR_NATURALIDADE_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.ATUALIZAR_NATURALIDADE_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_NATURALIDADE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
